import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {MdbValidationModule} from "mdb-angular-ui-kit/validation";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-validation-error',
  imports: [
    MdbValidationModule,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './validation-error.component.html',
  standalone: true,
  styleUrl: './validation-error.component.scss'
})
export class ValidationErrorComponent {
  text = input.required<string>()
}
